import template     from 'designer/thumb-page-behaviors-only.ejs';
import constants from 'Constants';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import ThumbPageItemView from './ThumbPageItemView';

//=========================================================
// This is a view on a single thumbnail page item
//=========================================================
class ThumbPageBehaviorsOnlyView extends ThumbPageItemView {


    initialize( opts ) {
        this.options = opts || {};

        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;

        this.model.set("hasActiveBehaviors", false, constants.MODEL_SILENT);
        this.model.set("behaviorsOnly", opts.behaviorsOnly, constants.MODEL_SILENT);
        
        return this;
    }

    loadPageItemObjects(){
       //thumbPageListUtil.updateBehaviorsOnly(this.model, true);
    }
}

export default ThumbPageBehaviorsOnlyView;
